import { useCurrentTimestamp } from "pages/Event/hooks/utils/useCurrentTimestamp";
import parse from "parse-duration";

const oneSec = parse("1 second") as number;

export const useCurrentSecond = () => {
  return useCurrentTimestamp(oneSec);
};
